import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';

export const quotationApi = createApi({
   reducerPath: 'quotationApi',
   baseQuery: baseQueryWithReauth,
   tagTypes: ['Quotation'],
   endpoints: (builder) => ({
      createQuotation: builder.mutation({
         query: (req) => {
            const formData = new FormData();
            for (const key in req) {
               if (key === 'signature' && req[key]) {
                  formData.append('signature', req[key]);
               } else if (key === 'quotationDetails') {
                  req[key].forEach((detail, index) => {
                     for (const detailKey in detail) {
                        formData.append(
                           `quotationDetails[${index}][${detailKey}]`,
                           detail[detailKey],
                        );
                     }
                  });
               } else {
                  formData.append(key, req[key]);
               }
            }

            return {
               url: 'quotation/create',
               method: 'POST',
               body: formData,
            };
         },
         invalidatesTags: [{ type: 'Quotation', id: 'LIST' }],
      }),

      getQuotations: builder.query({
         query: ({ limit = 10, page = 0, orderBy = 'DESC', search = '', sortBy = '' }) => ({
            url: `quotation?limit=${limit}&page=${page}&orderBy=${orderBy}&search=${search}&sortBy=${sortBy}`,
            method: 'GET',
         }),
         providesTags: [{ type: 'Quotation', id: 'LIST' }],
      }),

      findQuotation: builder.query({
         query: (id) => ({
            url: `quotation/${id}`,
            method: 'GET',
         }),
         providesTags: (result, error, id) => [{ type: 'Quotation', id }],
      }),

      updateQuotation: builder.mutation({
         query: (req) => {
            const formData = new FormData();
            for (const key in req) {
               if (key === 'signature' && req[key]) {
                  formData.append('signature', req[key]);
               } else if (key === 'quotationDetails') {
                  req[key].forEach((detail, index) => {
                     for (const detailKey in detail) {
                        formData.append(
                           `quotationDetails[${index}][${detailKey}]`,
                           detail[detailKey],
                        );
                     }
                  });
               } else {
                  formData.append(key, req[key]);
               }
            }

            return {
               url: `quotation/update/${req.id}`,
               method: 'PATCH',
               body: formData,
            };
         },
         invalidatesTags: (result, error, { id }) => [
            { type: 'Quotation', id },
            { type: 'Quotation', id: 'LIST' },
         ],
      }),

      // updateQuotation: builder.mutation({
      //     query: (req) => ({
      //         url: `quotation/update/${req.id}`,
      //         method: 'PUT',
      //         body: req,
      //     }),
      //     invalidatesTags: (result, error, { id }) => [{ type: 'Quotation', id }],
      // }),

      updateQuotationStatus: builder.mutation({
         query: (id) => ({
            url: `quotation/status/${id}`,
            method: 'PUT',
         }),
      }),

      getQuotationStatus: builder.query({
         query: () => ({
            url: 'quotation/status',
            method: 'GET',
         }),
      }),

      getQuotationPreview: builder.query({
         query: (id) => ({
            url: `quotation/${id}/preview`,
            method: 'GET',
         }),
         providesTags: (result, error, id) => [{ type: 'Quotation', id }],
      }),

      sendQuotationEmail: builder.mutation({
         query: (id) => ({
            url: `quotation/${id}/send`,
            method: 'POST',
            body: {},
         }),
         invalidatesTags: (result, error, id) => [
            { type: 'Quotation', id },
            { type: 'Quotation', id: 'LIST' },
         ],
      }),

      getQuotationLogs: builder.query({
         query: (id) => ({
            url: `quotation/${id}/logs`,
            method: 'GET',
         }),
         providesTags: (result, error, id) => [{ type: 'Quotation', id }],
      }),
   }),
});

export const {
   useCreateQuotationMutation,
   useUpdateQuotationMutation,
   useUpdateQuotationStatusMutation,
   useGetQuotationsQuery,
   useFindQuotationQuery,
   useGetQuotationStatusQuery,
   useGetQuotationPreviewQuery,
   useSendQuotationEmailMutation,
   useGetQuotationLogsQuery,
} = quotationApi;
